import { toast } from "react-toastify";

import cn from "@utils/cn";

import "./toastify.css";
import Icon from "@components/elements/Icon";

const CLOSE_BUTTON_CLASS_NAMES = cn(`
  absolute
  right-3
  top-2
  text-gallery-500
  duration-200
  hover:text-gallery-200
  hover:bg-gallery-700/60
  active:bg-gallery-900
  rounded-md
  cursor-pointer
  p-[0.15rem]
`);

const SESSION_STORAGE_TOAST_KEY = "toasts";
const QUEUED_TOAST_DELAY = 1000;

const __getToastsFromSessionStorage = () => {
  return JSON.parse(sessionStorage.getItem(SESSION_STORAGE_TOAST_KEY)) || [];
};

/***************************************************************************************************
** ToastNotification
***************************************************************************************************/

const ToastNotification = ({ data = {}, closeToast }) => {
  const {
    type,
    value,
  } = data;

  return (
    <div className="flex flex-col gap-1 pt-3 pb-4 px-5">
      <div className={cn("font-medium tracking-wide", {
        "text-emerald-300": type === "success",
        "text-rose-300": type === "error",
        "text-amber-300": type === "warning",
        "text-sky-300": type === "info",
      })}>
        {type.toUpperCase()}
      </div>

      <div
        className="leading-snug"
        dangerouslySetInnerHTML={{ __html: value }}
      />

      <div
        className={CLOSE_BUTTON_CLASS_NAMES}
        onClick={closeToast}
      >
        <Icon iconName="xmark" size="md" fixedWidth={true} />
      </div>
    </div>
  );
};

/***************************************************************************************************
** notify
***************************************************************************************************/

const notify = ({ type, value }) => {
  if (!type || !value) return;

  toast(<ToastNotification />, {
    className: "border border-gallery-700",
    position: "top-right",
    autoClose: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    closeButton: false,
    draggable: true,
    draggablePercent: 40,
    hideProgressBar: true,
    data: {
      type: type,
      value: value,
    },
  });
};

/***************************************************************************************************
** notifyOnReload
***************************************************************************************************/

const notifyOnReload = (args) => {
  const toasts = __getToastsFromSessionStorage();
  toasts.push(args);
  sessionStorage.setItem(SESSION_STORAGE_TOAST_KEY, JSON.stringify(toasts));
};

/***************************************************************************************************
** processToastQueue
***************************************************************************************************/

const processToastQueue = () => {
  const toasts = __getToastsFromSessionStorage();

  toasts.forEach((args, index) => {
    setTimeout(() => {
      notify(args);
    }, QUEUED_TOAST_DELAY * index);
  });

  sessionStorage.removeItem(SESSION_STORAGE_TOAST_KEY);
};

/***************************************************************************************************
** updateToast (Unused)
***************************************************************************************************/

// const _updateToast = ({ type, value, toastId, ...args }) => {
//   if (!type || !value || !toastId) return;

//   const typeTitle = type.toUpperCase();

//   const Content = (
//     <div>
//       <b>{typeTitle}</b>
//       <div dangerouslySetInnerHTML={{ __html: value }} />
//     </div>
//   );

//   toast.update(toastId, {
//     render: () => Content,
//     type: type,
//     autoClose: args.autoClose ?? 5000,
//     delay: args.delay ?? 0,
//   });
// };

/**************************************************************************************************/

export default {
  success: (value) => notify({
    type: "success",
    value: value,
  }),
  error: (value) => notify({
    type: "error",
    value: value,
  }),
  info: (value) => notify({
    type: "info",
    value: value,
  }),
  notify: (args) => notify(args),
  processQueue: processToastQueue,
  onReload: notifyOnReload,
  // update: updateToast,
};
